import type { BattleDataContext } from '@pokebot/shared/battle';
import { balanceSchema } from '@pokebot/shared/data/schemas/balance';
import { moveDataSchema } from '@pokebot/shared/data/schemas/entities/move';
import { pokemonSpeciesSchema } from '@pokebot/shared/data/schemas/entities/pokemon';
import type { MoveData } from '@pokebot/shared/data/schemas/entities/move';
import type { PokemonSpecies } from '@pokebot/shared/data/schemas/entities/pokemon';

import balanceJson from '@pokebot/shared/data/balance.json';
import bulbasaurJson from '@pokebot/shared/data/pokemon/bulbasaur.json';
import rattataJson from '@pokebot/shared/data/pokemon/rattata.json';
import quickAttackJson from '@pokebot/shared/data/moves/quick_attack.json';
import tackleJson from '@pokebot/shared/data/moves/tackle.json';
import vineWhipJson from '@pokebot/shared/data/moves/vine_whip.json';

const balance = balanceSchema.parse(balanceJson);

const speciesById = new Map<string, PokemonSpecies>([
  ['bulbasaur', pokemonSpeciesSchema.parse(bulbasaurJson)],
  ['rattata', pokemonSpeciesSchema.parse(rattataJson)],
]);

const movesById = new Map<string, MoveData>([
  ['tackle', moveDataSchema.parse(tackleJson)],
  ['vine_whip', moveDataSchema.parse(vineWhipJson)],
  ['quick_attack', moveDataSchema.parse(quickAttackJson)],
]);

/** Browser-safe `BattleDataContext` (no Node `fs`). Pilot entity set for dev battle. */
export function createClientBattleDataContext(): BattleDataContext {
  return {
    getSpecies(speciesId: string): PokemonSpecies {
      const species = speciesById.get(speciesId);
      if (!species) {
        throw new Error(`unknown speciesId: ${speciesId}`);
      }
      return species;
    },
    getMove(moveId: string): MoveData {
      const move = movesById.get(moveId);
      if (!move) {
        throw new Error(`unknown moveId: ${moveId}`);
      }
      return move;
    },
    balance: balance.battle,
  };
}
